import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";
import styles from "./paymentNew.module.css";

import { checkValidCoupon } from "../../../../actions/payment";
import { useAlert } from "../../../../Context/AlertModalContext";
const PaymentPromo = ({ product, validCoupon, onResetPromocode, onPromoCodeValid, onPromoCodeError }) => {
    const alert = useAlert();

    const [coupon, setCoupon] = useState("");
    const [showPromoModal, setShowPromoModal] = useState(false);
    const checkCouponValidity = async () => {
        if (!coupon) {
            return alert.setModal({ show: true, message: "Please enter a promo code", title: "Error" });
        }

        try {
            const response = await checkValidCoupon(product, coupon);
            if (response.valid) {
                onPromoCodeValid(response.coupon);
                setShowPromoModal(false);
                return alert.setModal({ show: true, message: "Coupon code applied successfully.", title: "Success" });
            } else {
                return alert.setModal({ show: true, message: "Please enter a valid promo code.", title: "Error" });
            }
        } catch (error) {
            return alert.setModal({ show: true, message: error.message || "Something went wrong. Please try again.", title: "Error" });
        }
    };

    const closePromoModal = async () => {
        setCoupon("");
        setShowPromoModal(false)
    }
    const removeCoupon = async () => {
        // Reset coupon
        setCoupon("");
        onResetPromocode();
        return alert.setModal({ show: true, message: "Coupon removed successfully.", title: "Success" });
    }

    return (
        <div>
            {validCoupon ? (
                <div className={styles.coupon_list}>
                    <span>Coupon: {validCoupon.id}</span>
                    <span
                        className={styles.icon}
                        onClick={removeCoupon}
                    >
                        <i className="bi bi-trash"></i>
                    </span>
                </div>
            ) : (
                <div className={styles.redeempromocode} onClick={() => setShowPromoModal(true)}>
                    <p>
                        <span style={{ marginRight: "12px" }}>
                            <svg
                                viewBox="0 0 27 27"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M19.25 7.75H19.2375M2.2625 15.7625L11.225 24.725C11.4572 24.9574 11.7329 25.1418 12.0364 25.2677C12.3399 25.3935 12.6652 25.4582 12.9937 25.4582C13.3223 25.4582 13.6476 25.3935 13.9511 25.2677C14.2546 25.1418 14.5303 24.9574 14.7625 24.725L25.5 14V1.5H13L2.2625 12.2375C1.79687 12.7059 1.53552 13.3395 1.53552 14C1.53552 14.6605 1.79687 15.2941 2.2625 15.7625Z"
                                    stroke="#242424"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>

                    </p><p> Redeem your promo code</p>
                </div>
            )}
            <Modal className="customer-modal-without-header-footer" centered show={showPromoModal} onHide={closePromoModal}>
                <Modal.Body className={styles.promoModalBody}>
                    <p className={styles.promoModalBodyTitle}>Redeem your promo code</p>
                    <div className="row vstack gap-5 my-3">
                        <div className="col">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter your promo code"
                                value={coupon}
                                onChange={(e) => setCoupon(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="hstack gap-2 justify-content-center">
                        <button className="global-cancel-button" onClick={closePromoModal}>Cancel</button>
                        <button className="global-save-button" onClick={checkCouponValidity}>Apply</button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default PaymentPromo;